import { render, staticRenderFns } from "./SuspendAccount.vue?vue&type=template&id=6f707ca4"
import script from "./SuspendAccount.vue?vue&type=script&lang=js"
export * from "./SuspendAccount.vue?vue&type=script&lang=js"
import style0 from "./SuspendAccount.vue?vue&type=style&index=0&id=6f707ca4&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f707ca4')) {
      api.createRecord('6f707ca4', component.options)
    } else {
      api.reload('6f707ca4', component.options)
    }
    module.hot.accept("./SuspendAccount.vue?vue&type=template&id=6f707ca4", function () {
      api.rerender('6f707ca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailAccounts/SuspendAccount.vue"
export default component.exports